export enum PolicyConfigDecisionAttributeFieldResultTypes {
    MATCH = "MATCH",
    NOT_MATCH = "NOT_MATCH",
    NOT_EQUAL = "NE",
    GREATER_THAN = "GT",
    EQUAL_TO = "EQ",
    LESS_THAN = "LT",
    NULL = "NULL",
    NOT_NULL = "NOT_NULL",
    BLANK = "BLANK",
    NOT_BLANK = "NOT_BLANK",
}